import { apiRequest, buildQuery } from "@/apis/client";
import type { AuditLogsQuery, AuditLogsResponse } from "@/apis/types";

export const auditLogsApi = {
  list(params: AuditLogsQuery = {}): Promise<AuditLogsResponse> {
    const query = buildQuery({
      page: params.page ?? 1,
      limit: params.limit ?? 25,
      app_name: params.app_name,
      user_id: params.user_id,
    });
    return apiRequest<AuditLogsResponse>(`/admin/audit-logs${query}`);
  },
};
